import { React } from "react";
import { TextField, Box } from "@mui/material";

const renderStringMore = (source, content) => {
  const limit = 30;
  const StringSource = String(source);
  if (StringSource.length > limit) {
    return (
      <div>
        <Box className="BoxCampaignDetailArea">
          <TextField
            multiline
            rows={4}
            id="outlined-read-only-input"
            label={content}
            defaultValue={source}
            InputProps={{
              readOnly: true,
            }}
            size="small"
            style={{
              minWidth: "300px",
              marginTop: "4px",
              marginBottom: "2px",
            }}
          />
        </Box>
      </div>
    );
  } else {
    return (
      <div>
        <Box className="BoxCampaignDetail">
          <div className="valueCampaignDetail">
            <TextField
              id="outlined-read-only-input"
              label={content}
              defaultValue={source}
              InputProps={{
                readOnly: true,
              }}
              size="small"
              style={{
                minWidth: "300px",
                marginTop: "4px",
                marginBottom: "2px",
              }}
            />
          </div>
        </Box>
      </div>
    );
  }
};

export default function CampaignDetailForm({ item }) {
  const content = item.key;
  const value = item.value;

  return <div>{renderStringMore(value, content)}</div>;
}
